<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-现有库存-修改
    -->
    <el-dialog
    title="现有库存操作"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

        <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
          <div>价格优先级：现有库存<城市区域定价<会员折扣<单独定价</div>
          <el-tabs v-model="activeTab">
            <el-tab-pane label="现有库存价" name="ba"></el-tab-pane>
            <el-tab-pane label="折扣" name="jh"></el-tab-pane>
            <el-tab-pane label="城市价格" name="cs"></el-tab-pane>
            <el-tab-pane label="单独定价" name="dd"></el-tab-pane>
            <el-tab-pane label="预购设置" name="yg"></el-tab-pane>
            <el-tab-pane label="进货" name="zk"></el-tab-pane>

          </el-tabs>

          <div v-if="activeTab == 'yg'">
              
              <el-form-item label="是否开启预购" prop="pre_order">
                <el-switch v-model="form.pre_order" active-color="#13ce66" 
              inactive-color="#ff4949"  @change="handleBlur(scope.row,'pre_order')"
              :active-value="1" :inactive-value="0"></el-switch>


              </el-form-item>



  
              <el-form-item label="预计发货时间" prop="line_price">
                <el-input v-model="form.pre_date" placeholder="预计发货时间：两月内发货" class="max-w460"></el-input>
              </el-form-item>
      
  
              <el-form-item label="预购单价" prop="pre_price">
                <el-input v-model="form.pre_price" placeholder="请输入预购单价" class="max-w460"></el-input>
              </el-form-item>


              <el-form-item label="预购限购" prop="pre_limit">
                <el-input v-model="form.pre_limit" placeholder="请输入预购限购" class="max-w460"></el-input>
              </el-form-item>
      
            </div>
  

          <div>
            <el-table-column prop="virtualInventoryAlert" label="是否为预购商品">


</el-table-column>

          </div>



          <div v-if="activeTab == 'ba'">
              
            <el-form-item label="销售价" prop="product_price">
              <el-input v-model="form.product_price" placeholder="请输入销售价" class="max-w460"></el-input>
            </el-form-item>

            <el-form-item label="划线价" prop="line_price">
              <el-input v-model="form.line_price" placeholder="请输入划线价" class="max-w460"></el-input>
            </el-form-item>
    

            <el-form-item label="实际库存" prop="actualInventory">
              {{ form.actualInventory }}
            </el-form-item>
    

            <el-form-item label="虚拟库存" prop="virtualInventory">
              <el-input v-model="form.virtualInventory" placeholder="请输入虚拟库存" class="max-w460"></el-input>
            </el-form-item>
    
    
      

          </div>


          <div v-if="activeTab == 'dd'">
              
              <sku_prices :warehouse_inventorys_id="warehouse_inventorys_id"></sku_prices>

          </div>





        
          <div v-if="activeTab == 'cs'">

            <div v-loading="cloading">
      
                <div class="common-form">设置城市价格（选择城市会展开下一级）</div>

                <el-form-item label="是否开启城市价格" >
            
                  <el-radio-group v-model="form.is_city_open">
                  <el-radio :label="1" >开启</el-radio>
                  <el-radio :label="0" >不开启</el-radio>
      
                </el-radio-group>
                
                  
                </el-form-item>
              
                <el-tree
                  v-loading="cloading"
                  element-loading-text="拼命加载中"
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                  empty-text=""
                  :data="province_list"
                  node-key="id"
                  default-expand-all
                  @node-drop="handleDrop"
                  @node-click="handleClick"
                  draggable
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  ref="tree"
                >
                  <span class="custom-tree-node"  style=" width: 100%; " slot-scope="{ node, data }">
                    <span class="m30">{{ data.name }}</span>

                    <span class="m30">定价：{{ data.price?data.price:"未定价" }}</span>
                  
                  <a style="margin-left: 40px;" v-if="data.status==1" v-on:click="setting(data.id,data.level)">设置</a>
          <!--
                    <a v-if="data.level==1 && data.status==1 && data_setting != 1" style="margin-left: 20px;" 
                    v-on:click="sync(data.id,data.level)">同步数据</a> -->
                    <el-switch style="margin-left: 20px;" :key="data.id"  v-model="data.status" 
                    :active-value="1"
                    :inactive-value="0"
                    @change="isDefaultChange(data.id,data.level,data.status)"></el-switch>
                    
                    <div style="clear: both;"></div>
                  </span>
                </el-tree>
              </div>

              <Setting v-if="open_cadd" :open_add="open_cadd" :warehouse_inventorys_id="warehouse_inventorys_id" :obj="obj" @closeDialog="closeProductDialogFunc($event)"> </Setting>



          </div>






      
      <div class="common-form" v-if="activeTab == 'jh'">进货折扣</div>
      <div v-if="activeTab == 'jh'">
          进货折扣不针对sku生效，针对商品生效
      </div>
      <el-form-item label="会员折扣设置："  v-if="activeTab == 'jh'">
      <el-radio-group v-model="form.is_alone_grade">
        <el-radio :label="0" :disabled="form.grade_model==1?true:false">默认折扣</el-radio>
        <el-radio :label="1" :disabled="form.grade_model==1?true:false">单独设置折扣(百分比)</el-radio>
        <el-radio :label="2">单独设置折扣(固定金额)</el-radio>
      </el-radio-group>
      <div class="gray9" v-if="form.is_alone_grade==0">默认折扣：默认为用户所属会员等级的折扣率</div>
      <div v-if="form.is_alone_grade==1" class="max-w460">
        <el-table
          :data="form.gradeList"
          border
          size="mini"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="会员等级">
          </el-table-column>
          <el-table-column
            prop="name"
            label="折扣">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_equity" type="number" placeholder="请输入折扣"></el-input>
                <span class="ml10">%</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="form.is_alone_grade==2" class="max-w460">
        <el-table
          :data="form.gradeList"
          border
          size="mini"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="会员等级">
          </el-table-column>
          <el-table-column
            prop="name"
            label="金额">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_fixed" type="number" placeholder="请输入金额"></el-input>
                <span class="ml10">元</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

      <div class="common-form"  v-if="activeTab == 'zk'">门店进货</div>
      <el-form-item label="选择限购方式" prop="limit_type"  v-if="activeTab == 'zk'">
        <el-radio-group v-model="form.limit_type">
              <el-radio label="no">不开启</el-radio>
              <el-radio label="month">月度</el-radio>
              <el-radio label="twomonth">两月</el-radio>
              <el-radio label="quarter">季度</el-radio>
              <el-radio label="total">累计</el-radio> 
        </el-radio-group>
      </el-form-item>

    <el-form-item label="商品限购："  v-if="activeTab == 'zk'">
      <el-input type="number" v-model="form.buy_limit" class="max-w460"></el-input>
    </el-form-item>

      <!-- <el-form-item label="最小下单金额:"  v-if="activeTab == 'zk'">
        <el-input type="number" min="0" v-model="form.buy_price_limit" class="max-w460"></el-input>
      </el-form-item> -->


      <el-form-item label="商品起订数："  v-if="activeTab == 'zk'">
        <el-input type="number" min="0" v-model="form.buy_num" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="商品起订最大数："  v-if="activeTab == 'zk'">
        <el-input type="number" min="0" v-model="form.buy_max_num" class="max-w460"></el-input>
      </el-form-item>

      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>

  </div>
</el-dialog>
  
</template>

<script>
import Existing_inventoryApi from '@/api/existing_inventory.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import sku_prices from './../../../../product/sku/sku_prices.vue';

import CityApi from '@/api/city.js';
  import Setting from './setting';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
     Setting,
     sku_prices
  },
  data() {
    return {
      activeTab: 'ba',
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        limit_type:"no",
        buy_limit:0,
        buy_num:0,
        buy_price_limit:0,
        buy_max_num:0,  
        gradeList:[],
        is_alone_grade:0,

        actualInventory:0,
        virtualInventory:0,
        line_price:0,
        product_price:0,

        pre_order:0,
        pre_date:"",
        pre_price:0,
        pre_limit:0

      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入现有库存名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",


      cloading:false,
      province_list: [],
      params:{
          id: 0,
          type: 0,
        },
        open_cadd:false,
        flag:false,

    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getParams()
  },
  props: ["open_add","warehouse_inventorys_id"],
  methods: {
    handleDrop(draggingNode, dropNode, dropType, ev) {
        console.log("tree drop: ", dropNode.label);
      },
      isDefaultChange(id,level,status){
        var self = this;
        let params = {
          id:id,
          level:level,
          status:status?1:0,
          warehouse_inventorys_id:self.warehouse_inventorys_id,
        }
        this.flag = false;
        CityApi.open(params, true).then(res => {
            console.log(res)
            if(res.msg == "开启成功"){
                self.$message({
                message:"设置成功",
                type: 'success',
              });
              self.flag = true;
              setTimeout(function(){
                  self.handleClick({
                  id:id,
                  type:level,
                  level:level,
                  end:0
                })
              },500)
              
            }else{
              self.flag = true;
                self.$message({
                message: res.msg,
                type: 'error'
              });
            }
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });

       

      },  

   // 点击
   handleClick(e){
    console.log('-------',this.flag)
    this.params.id = e.id;
          this.params.type = e.level;
 
          if(e.level>2){
            return false;
          }
          console.log('e',e)
          if (!e.children && e.end==0){

            this.getParams(e);
          }
    
      },
          /*获取配置数据*/
          getParams(node) {
            let self = this;
            let params = self.params;
            params.warehouse_inventorys_id=self.warehouse_inventorys_id;
            CityApi.getTree(params, true).then(res => {
                self.data_setting = res.data.data_setting
                if (self.params.id>0 && self.params.type>0){
    
                  self.append(node, res.data.list);
                  self.flag = true;
                  self.$forceUpdate()
                } else {
                  self.province_list = res.data.list;
                }  
                self.loading=false;
              })
              .catch(error => {
                self.loading=false;
              });
      },

      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },

         /*关闭弹窗*/
         closeProductDialogFunc(e) {
            this.open_cadd = e.openDialog;

      },
      setting(id,level){
        var self = this;
        this.flag = false;
        this.obj = {
          level:level,
          id:id,
          purchasePrice:self.form.purchasePrice,
          product_price:self.form.product_price,
          warehouse_inventorys_id:self.form.warehouse_inventorys_id
        }
        this.open_cadd = true;
        setTimeout(function(){
          self.flag = true;
        },350)
      },

   // 增加
   append(data, children_data) {
        if (!children_data.length) data.end = 1;
        children_data.forEach(e => {
          if (!data.children) {
            this.$delete(data, 'children')
            this.$set(data, "children", []);
          }
          data.children.push(e);
        });
        this.$forceUpdate();
      },

      remove(node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex((d) => d.id === data.id);
        children.splice(index, 1);
      },
      renderContent(h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
            <span>{node.label}</span>
            <span>
              <el-button
                size="mini"
                type="text"
                on-click={() => this.append(data)}
              >
                Append
              </el-button>
              <el-button
                size="mini"
                type="text"
                on-click={() => this.remove(node, data)}
              >
                Delete
              </el-button>
            </span>
          </span>
        );
      },
      handleDrop(draggingNode, dropNode, dropType, ev) {
        console.log("tree drop: ", dropNode.label);
      },





    
  
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Existing_inventoryApi.detail({warehouse_inventorys_id: self.warehouse_inventorys_id},true).then(res => {
        if (res.data.alone_grade_equity != null && typeof res.data.alone_grade_equity != 'undefined' 
          && res.data.is_alone_grade == 1) {
            let equitys = res.data.alone_grade_equity;
            res.data.gradeList.forEach(item => {
              item.product_equity = equitys[item.grade_id];
            });
          }  

             /*固定金额 */
        if (res.data.alone_grade_equity != null && typeof res.data.alone_grade_equity != 'undefined'
         && res.data.is_alone_grade == 2) {
            let equitys = res.data.alone_grade_equity;
            res.data.gradeList.forEach(item => {
              item.product_fixed = equitys[item.grade_id];
            });
          }

        
        self.form = res.data;
          self.loading = false;

      
          
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
 
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          form.alone_grade_equity = self.convertJson(self.form.gradeList, form.is_alone_grade);
          Existing_inventoryApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
      /*转JSON字符串*/
      convertJson(list, type) {
      let obj = {};
      if (type == 2) {
        list.forEach(item => {
          obj[item.grade_id] = item.product_fixed;
        });
      } else if (type == 1) {
        list.forEach(item => {
          obj[item.grade_id] = item.product_equity;
        });
      } else if (type == 20) {
        list.forEach(item => {
          obj[item.grade_id] = item.independent_commission;
        });
      }else if(type == 30){
        list.forEach(item => {
          if(item.product_lateral_ratio){
            obj[item.grade_id] = item.product_lateral_ratio;
          }else{
            obj[item.grade_id] = 0;
          }
        
        });
       
      }
      return JSON.stringify(obj);
    },


    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/existing_inventory/index/part/edit.vue